import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Stations from "./pages/Station";
import OrganisationWallet from "./pages/OrganisationWallet";
import Login from "./pages/Login/Login";
import Callback from "./pages/Login/Callback";
import ResetPassword from "./pages/Login/ResetPassword";
import ProtectedRoute from "./ProtectedRoute";
import LandingPage from "./pages/LandingPage/LandingPage";
import ViewDetails from "./pages/ViewDetails";
import ManageUser from "./pages/ManageUser";
import Support from "./pages/Support";
import Account from "./pages/Account";
import Members from "./pages/Members";
import LoginMethods from "./pages/LoginMethods";
import AcceptInvite from "./pages/Login/AcceptInvite";
import ChatDetailWrapper from "./features/support/ChatDetailWrapper";

// Maintenance — fully isolated module
import MaintenanceGuard from "./features/maintenance/shared/MaintenanceGuard";
import MaintenanceStations from "./features/maintenance/stations/MaintenanceStations";
import StationDetail from "./features/maintenance/stations/StationDetail";
import MaintenanceDevices from "./features/maintenance/devices/MaintenanceDevices";
import DeviceDetail from "./features/maintenance/devices/DeviceDetail";
import AuditLog from "./features/maintenance/audit/AuditLog";
import PricingManagement from "./features/maintenance/pricing/PricingManagement";
import ProcurementConsole from "./features/maintenance/procurement/ProcurementConsole";
import VehicleManagement from "./features/maintenance/vehicles/VehicleManagement";
import UtilizationDashboard from "./features/maintenance/utilization/UtilizationDashboard";
import OverviewDashboard from "./features/maintenance/overview/OverviewDashboard";
import SessionsConsole from "./features/maintenance/sessions/SessionsConsole";
import TransactionsReport from "./features/maintenance/transactions/TransactionsReport";
import CashbackConsole from "./features/maintenance/cashback/CashbackConsole";
import AnomalyConsole from "./features/maintenance/anomalies/AnomalyConsole";
import ZitadelProvisioning from "./features/maintenance/zitadel/ZitadelProvisioning";
import PricingCoverage from "./features/maintenance/settlement/PricingCoverage";
import SettlementOverview from "./features/maintenance/settlement/SettlementOverview";
import SettlementParties from "./features/maintenance/settlement/SettlementParties";
import SettlementOrgSetup from "./features/maintenance/settlement/SettlementOrgSetup";
import RateCardEditor from "./features/maintenance/settlement/RateCardEditor";
import SettlementOrgRuns from "./features/maintenance/settlement/SettlementOrgRuns";
import SettlementReport from "./features/maintenance/settlement/SettlementReport";
import OrgSettlements from "./features/organisationWallet/OrgSettlements";
import OrgWalletManagement from "./features/maintenance/orgWallet/OrgWalletManagement";
import RefundConsole from "./features/maintenance/refunds/RefundConsole";
import OcpiPartners from "./features/maintenance/ocpi/OcpiPartners";
import PredictionsConsole from "./features/maintenance/predictions/PredictionsConsole";
import OcpiPartnerDetail from "./features/maintenance/ocpi/OcpiPartnerDetail";
import OcpiRoles from "./features/maintenance/ocpi/OcpiRoles";
import OcpiLogs from "./features/maintenance/ocpi/OcpiLogs";
import OcpiSettings from "./features/maintenance/ocpi/OcpiSettings";
import OrgWalletView from "./features/organisationWallet/OrgWalletView";

const AppRoutes: React.FC = () => {
  return (
    // <BrowserRouter>
    <Routes>
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stations"
        element={
          <ProtectedRoute>
            <Stations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/wallet"
        element={
          <ProtectedRoute>
            <OrganisationWallet />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stations/:stationId"
        element={
          <ProtectedRoute>
            <ViewDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/manageuser"
        element={
          <ProtectedRoute>
            <ManageUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="/account"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/members"
        element={
          <ProtectedRoute>
            <Members />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/login-methods"
        element={
          <ProtectedRoute>
            <LoginMethods />
          </ProtectedRoute>
        }
      />
       <Route
        path="/transactions"
        element={
          <ProtectedRoute>
            <OrganisationWallet />
          </ProtectedRoute>
        }
      />
      <Route
        path="/support"
        element={
          <ProtectedRoute>
            <Support />
          </ProtectedRoute>
        }
      />
      <Route
        path="/support/chat/:conversationId"
        element={
          <ProtectedRoute>
            <ChatDetailWrapper />
          </ProtectedRoute>
        }
      />

      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      {/* Zitadel appends /login to the Login V2 base URI; tolerate a base URI
          that already ends in /login so a config slip never strands sign-in. */}
      <Route path="/login/login" element={<Login />} />
      <Route path="/callback" element={<Callback />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />

        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<Callback />} />

        {/* Maintenance routes — isolated, guarded by role + URL */}
        <Route path="/maintenance/overview" element={<ProtectedRoute><MaintenanceGuard><OverviewDashboard /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/sessions" element={<ProtectedRoute><MaintenanceGuard><SessionsConsole /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/transactions" element={<ProtectedRoute><MaintenanceGuard><TransactionsReport /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/cashback" element={<ProtectedRoute><MaintenanceGuard><CashbackConsole /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/stations" element={<ProtectedRoute><MaintenanceGuard><MaintenanceStations /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/stations/:id" element={<ProtectedRoute><MaintenanceGuard><StationDetail /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/devices" element={<ProtectedRoute><MaintenanceGuard><MaintenanceDevices /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/devices/:id" element={<ProtectedRoute><MaintenanceGuard><DeviceDetail /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/procurement" element={<ProtectedRoute><MaintenanceGuard><ProcurementConsole /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/anomalies" element={<ProtectedRoute><MaintenanceGuard><AnomalyConsole /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/pricing" element={<ProtectedRoute><MaintenanceGuard><PricingManagement /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/predictions" element={<ProtectedRoute><MaintenanceGuard><PredictionsConsole /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/ocpi" element={<ProtectedRoute><MaintenanceGuard><OcpiPartners /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/ocpi/partners/:id" element={<ProtectedRoute><MaintenanceGuard><OcpiPartnerDetail /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/ocpi/roles" element={<ProtectedRoute><MaintenanceGuard><OcpiRoles /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/ocpi/logs" element={<ProtectedRoute><MaintenanceGuard><OcpiLogs /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/ocpi/settings" element={<ProtectedRoute><MaintenanceGuard><OcpiSettings /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/settlement" element={<ProtectedRoute><MaintenanceGuard><SettlementOverview /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/settlement/coverage" element={<ProtectedRoute><MaintenanceGuard><PricingCoverage /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/settlement/parties" element={<ProtectedRoute><MaintenanceGuard><SettlementParties /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/settlement/orgs/:orgId" element={<ProtectedRoute><MaintenanceGuard><SettlementOrgSetup /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/settlement/profile" element={<ProtectedRoute><MaintenanceGuard><RateCardEditor /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/settlement/orgs/:orgId/runs" element={<ProtectedRoute><MaintenanceGuard><SettlementOrgRuns /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/settlement/orgs/:orgId/runs/:periodKey/report" element={<ProtectedRoute><MaintenanceGuard><SettlementReport /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/settlements" element={<ProtectedRoute><OrgSettlements /></ProtectedRoute>} />
        <Route path="/org-wallet" element={<ProtectedRoute><OrgWalletView /></ProtectedRoute>} />
        <Route path="/maintenance/org-wallet" element={<ProtectedRoute><MaintenanceGuard><OrgWalletManagement /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/refunds" element={<ProtectedRoute><MaintenanceGuard><RefundConsole /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/vehicles" element={<ProtectedRoute><MaintenanceGuard><VehicleManagement /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/utilization" element={<ProtectedRoute><MaintenanceGuard><UtilizationDashboard /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/audit" element={<ProtectedRoute><MaintenanceGuard superAdminOnly><AuditLog /></MaintenanceGuard></ProtectedRoute>} />
        <Route path="/maintenance/zitadel" element={<ProtectedRoute><MaintenanceGuard superAdminOnly><ZitadelProvisioning /></MaintenanceGuard></ProtectedRoute>} />

        <Route path="*" element={<div>404: Page Not Found</div>} />
      </Routes>
    // </BrowserRouter>
  );
};

export default AppRoutes;
